import Event from "./libs/Event"
import Cart from "./libs/Cart"
import Wishlist from "./libs/Wishlist"
import Book from "./libs/Book"
import Preview from "./libs/Preview"
import Search from "./libs/Search"
import Coupon from "./libs/Coupon"
import Voucher from "./libs/Voucher"
import Language from "./libs/Language"
import User from "./libs/User"
import Ping from "./libs/Ping"

// Creating default global namespace
window.Dibook = window.Dibook || {}

// Main objects
window.Dibook.ping = window.Dibook.ping || Ping.createInstance()
window.Dibook.cart = window.Dibook.cart || Cart.createInstance()
window.Dibook.wishlist = window.Dibook.wishlist || Wishlist.createInstance()
window.Dibook.book = window.Dibook.book || Book.createInstance()
window.Dibook.event = window.Dibook.event || Event.createInstance()
window.Dibook.preview = window.Dibook.preview || Preview.createInstance()
window.Dibook.search = window.Dibook.search || Search.createInstance()
window.Dibook.coupon = window.Dibook.coupon || Coupon.createInstance()
window.Dibook.voucher = window.Dibook.voucher || Voucher.createInstance()
window.Dibook.language = window.Dibook.language || Language.createInstance()
window.Dibook.user = window.Dibook.user || User.createInstance()
